// eslint-disable-next-line no-shadow
export enum AuditLogProductCodes {
  LITTLE_SIS_CLASSROOM = 'lsc',
  LITTLE_SIS_PREMIUM = 'lsp',
  TEACHER_REVIEW = 'tr'
}

export interface AuditLogEntry {
 typeId: number;
 actionId: number;
 productCode: AuditLogProductCodes;
 logData?: {[key: string]: any};
 userId?: number;
 gId?: string;
 customerId?: number;
}

